import {asyncComponent} from 'react-async-component';
import GenericError from '../generic-error';
import React, {Component} from 'react';

/* istanbul ignore next */
const AsyncGenericError = asyncComponent({
    name: 'AsyncGenericError',
    resolve: () => Promise.resolve(GenericError),
    serverMode: 'defer'
});

/**
 * This may have more logic in the future
 * to display different types of error UIs and messages.
 */
export default class ErrorPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        /** @todo [SCRATCHPAD-1640] log edap event(s) */
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return <AsyncGenericError/>;
    }
}


// WEBPACK FOOTER //
// ./src/universal/components/error-page/error-page.js